// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-5da82d30] {\n  background: #252b34;\n  color: #c6c3b9;\n  font-family: \"Helvetica Neue\", sans-serif;\n  margin: 0 auto;\n  text-align: center;\n}\nh1[data-v-5da82d30] {\n  font-size: 8vmin;\n  font-weight: lighter;\n}\n.svg-loader[data-v-5da82d30] {\n  height: 20vmin;\n  padding: 3vmin 10vmin;\n  vertical-align: top;\n}", ""]);
// Exports
module.exports = exports;
